import EZAddToCartGiftGiverInfoModal from './EZAddToCartGiftGiverInfoModal'

export default EZAddToCartGiftGiverInfoModal
